import helloWorld from './hello-world';

// Add new posts here, newest first
// Set published: false on any post to hide it from the site
const posts = [
  helloWorld,
].filter((p) => p.published);

export default posts;
